import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/shared/contexts/LanguageContext';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const labels = {
    code:    { fr: '404', en: '404', es: '404' },
    title:   { fr: 'Page introuvable', en: 'Page not found', es: 'Página no encontrada' },
    body:    { fr: 'Cette page n\'existe pas ou a été déplacée.', en: 'This page doesn\'t exist or has been moved.', es: 'Esta página no existe o ha sido movida.' },
    home:    { fr: 'Retour au tableau de bord', en: 'Back to dashboard', es: 'Volver al panel' },
    back:    { fr: 'Page précédente', en: 'Previous page', es: 'Página anterior' },
  };

  const l = (key: keyof typeof labels) => labels[key][language as 'fr' | 'en' | 'es'] ?? labels[key].fr;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="max-w-sm w-full text-center space-y-6">
        <div className="space-y-2">
          <p className="text-8xl font-bold font-display text-primary/20 leading-none">
            {l('code')}
          </p>
          <h1 className="text-2xl font-bold font-display">{l('title')}</h1>
          <p className="text-sm text-muted-foreground">{l('body')}</p>
        </div>

        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate('/')}
            className="flex items-center justify-center gap-2 w-full py-3 bg-primary text-primary-foreground rounded-xl font-semibold hover:bg-primary/90 transition-colors"
          >
            <Home size={16} />
            {l('home')}
          </button>
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center gap-2 w-full py-3 bg-secondary text-secondary-foreground rounded-xl font-semibold hover:bg-secondary/80 transition-colors"
          >
            <ArrowLeft size={16} />
            {l('back')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
